import { Button, Grid, IconButton, List, ListItem, Paper, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function FTRLodgement(){
	return (
		<Grid
			container
			sx={{ p: 2 }}
			spacing={2}
			alignItems="stretch"
			flexDirection={"column"}
			component={Paper}
			maxWidth="lg"
		>
			<Grid item xs md={12}>
				<Typography variant="h4" color="primary.main" gutterBottom>
					Instructions for requesting an FTR
				</Typography>
			</Grid>
			<Grid item xs md={12} sx={{ mb: 2 }}>
				<Typography variant="body2">
					To find an offering for which review is being requested: Go to
					Partner Central. Scroll down to <b>AWS Partner Path</b>. Click on{" "}
					<b>Solutions Submitted for FTR</b>. Click on <b>Create Solution</b>{" "}
					and complete all required fields for the new listing. Select the
					solution once created. Click <b>Request Validation</b>
				</Typography>
			</Grid>
			<Grid item xs md={12} sx={{ ml: 4, mb: 2 }}>
				<List dense={true}>
					<ListItem>
						<FiberManualRecordIcon fontSize="small" />
						<Typography variant="body2" sx={{ ml: 2 }}>
							In the <b>Validations</b> section of the offering, upload your
						</Typography>
					</ListItem>
					<List component="div" disablePadding>
						<ListItem sx={{ pl: 4 }}>
							<Typography variant="body2" sx={{ ml: 2 }}>
								a. Completed self-assessment under <b>FTR Checklist</b>
							</Typography>
						</ListItem>
						<ListItem sx={{ pl: 4 }}>
							<Typography variant="body2" sx={{ ml: 2 }}>
								b. Architecture diagram
							</Typography>
						</ListItem>
						<ListItem sx={{ pl: 4 }}>
							<Typography variant="body2" sx={{ ml: 2 }}>
								c. AWS CIS Foundations Benchmark report under{" "}
								<b>Security Tool Report</b>
							</Typography>
						</ListItem>
					</List>
					<ListItem>
						<FiberManualRecordIcon fontSize="small" />
						<Typography variant="body2" sx={{ ml: 2 }}>
							You may upload multiple files in order to cover all accounts and
							AWS Regions where you process customer data.
						</Typography>
					</ListItem>
					<ListItem>
						<FiberManualRecordIcon fontSize="small" />
						<Typography variant="body2" sx={{ ml: 2 }}>
							AWS will review your submitted documents and provide
							confirmation upon FTR approval or email instructions for any
							remediations required.
						</Typography>
					</ListItem>
					<ListItem>
						<FiberManualRecordIcon fontSize="small" />
						<Typography variant="body2" sx={{ ml: 2 }}>
							Upon successfully completing an FTR, you gain immediate access
							to AWS Partner benefits including ‘qualified software’ badge,
							funding, marketing resources, and more.
						</Typography>
					</ListItem>
				</List>
			</Grid>
			<Grid item xs md={12}>
				<Typography variant="body2" sx={{ pt: 2 }}>
					<b>NOTE: </b>The Request Foundational Technical Review button will
					be disabled until you have uploaded files.
				</Typography>
			</Grid>
			<Grid item xs md={12}>
				<Typography variant="body2">
					You will also need to generate an application architecture diagram
					that complies with AWS diagram best-practices. 
					For additional details please see the AWS Reference Architecture Diagrams page.
					<IconButton 
						href="https://aws.amazon.com/architecture/reference-architecture-diagrams/?solutions-all.sort-by=item.additionalFields.sortDate&solutions-all.sort-order=desc&whitepapers-main.sort-by=item.additionalFields.sortDate&whitepapers-main.sort-order=desc&awsf.whitepapers-tech-category=*all&awsf.whitepapers-industries=*all"
						target="_blank"
						color="secondary"
					>
						<OpenInNewIcon />
					</IconButton>
				</Typography>
			</Grid>
			<Grid item xs md={12}>
				<Typography variant="body2">
					For additional detail on how to complete your FTR, please see the
					official AWS FTR Guide
					<IconButton 
						href="https://partnercentral.awspartner.com/ContentFolderPartner?id=0690h00000BGRJhAAP"
						target="_blank"
						color="secondary"
					>
						<OpenInNewIcon />
					</IconButton>
				</Typography>
			</Grid>
			<Grid item xs md={12}>
				<Typography variant="body2">
					For additional support or assistance with your FTR, please contact
					6pillars’ FTR Support and the team will respond within 1 business day.
					<IconButton 
						href="https://www.6pillars.ai/contact"
						target="_blank"
						color="secondary"
					>
						<OpenInNewIcon />
					</IconButton>
				</Typography>
			</Grid>
			<Grid item xs md={4}>
				<Button
					href="https://partnercentral.awspartner.com/APNLogin"
					target="_blank"
					variant="contained"
					sx={{
						width: 300,
						height: 40,
						bgcolor: "secondary.main",
						"&:hover": {
							bgcolor: "secondary.main",
							color: "secondary.contrastText",
						},
					}}
					endIcon={<OpenInNewIcon />}
				>
					AWS Partner Central Log-in
				</Button>
			</Grid>
		</Grid>
	)
}